export const ChevronIcon = {
    template: `
		<svg class="chevron-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.414 8.121">
			<g transform="translate(-872.513 -883.626)">
				<path class="chevron-path" d="M0,6,6,0l6,6" transform="translate(885.22 890.333) rotate(180)"/>
			</g>
		</svg>
	`
}
